import * as React from 'react';
import { formDataByType } from 'Utility/documentHandling';
import CarbonDioxideMeasurementForm from './CarbonDioxideMeasurement';
import DiagnosticExaminationForm from './DiagnosticExamination';
import NightOximetryForm from './NightOximetry';
import SleepPolygraphyForm from './SleepPolygraphy';
import SleepStudyForm from './SleepStudy';
import SpirometryForm from './Spirometry';

import type { TClpAndCnpTestsDocumentType, TRelevantDocumentType } from '../../utils';

const ClpAndCnpTestsForm = ({
  formData,
  document,
  viewing = false,
  documents,
  diagnosticExamKey,
}: IOwnProps): React.JSX.Element | null => {
  switch (document?._type) {
    case 'sleepPolygraphy':
      return (
        <SleepPolygraphyForm formData={formDataByType(formData, document)} viewing={viewing} documents={documents} />
      );
    case 'sleepStudy':
      return <SleepStudyForm formData={formDataByType(formData, document)} viewing={viewing} documents={documents} />;
    case 'spirometry':
      return <SpirometryForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'nightOximetry':
      return <NightOximetryForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'carbonDioxideMeasurement':
      return <CarbonDioxideMeasurementForm formData={formDataByType(formData, document)} viewing={viewing} />;
    case 'diagnosticExamination':
      return (
        <DiagnosticExaminationForm
          formData={formDataByType(formData, document)}
          viewing={viewing}
          diagnosticExamKey={diagnosticExamKey}
        />
      );
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<IDocumentWithTypeV2<TClpAndCnpTestsDocumentType>>;
  document?: IDocumentWithTypeV2<TClpAndCnpTestsDocumentType>;
  viewing?: boolean;
  documents: Array<IDocumentWithTypeV2<TRelevantDocumentType>>;
  diagnosticExamKey?: TDiagnosticExamKeys;
}

export default ClpAndCnpTestsForm;
